module.exports = __webpack_public_path__ + "static/media/QA.cdcc6159.svg";